<template>
  <li class="mobileMenu__listItem">
    <button
      v-if="list.length"
      class="mobileMenu__listLink"
      :class="{ 'mobileMenu__listLink--hasChild': list && list.length }"
      type="button"
      @click="openNext"
    >
      <span v-if="icon" class="mobileMenu__listIcon" :class="`${icon}`" />
      {{ label }}
      <span class="mobileMenu__listChevron icon-chevron-right-bold" />
    </button>
    <a v-else-if="href" :href="href" target="_blank" class="mobileMenu__listLink">
      <span class="mobileMenu__linkSpan">
        {{ label }}
      </span>
    </a>
    <nuxt-link :to="slug" @click.native="resetMenuState" class="mobileMenu__listLink" v-else>
      <span class="mobileMenu__linkSpan">
        {{ label }} <span class="mobileMenu__listLinkCount" v-if="count">{{ count }}</span>
        <span v-if="label === 'Powiadomienia' && unreadNotifications" class="mobileMenu__itemLabel">
          {{ unreadNotifications }}
        </span>
      </span>
    </nuxt-link>
    <ul
      v-if="list.length"
      :class="[
        'mobileMenu__list',
        { 'mobileMenu__list--open': activeMenuItem[menuName] === slugify(withParentLabel) },
      ]"
    >
      <li class="mobileMenu__header">
        <button
          class="mobileMenu__headerPrev icon-chevron-left-bold"
          @click="openPrev"
          type="button"
        />
        <nuxt-link :to="slug" @click.native="resetMenuState">
          {{ label }}
        </nuxt-link>
        <button
          class="mobileMenu__headerClose icon-line-close"
          type="button"
          @click="toggleMenu({ type: menuName })"
        />
      </li>
      <div
        class="mobileMenu__listSearch"
        v-if="activeMenuItem.category && activeMenuItem.category === slugify('Tonery i tusze')"
      >
        <search-toners-inks @submit="resetMenuState" />
      </div>
      <mobile-tree-menu
        v-for="(category, index) in list"
        :key="`${index}_${category.id}`"
        :list="category.children || []"
        :slug="category.slug"
        :label="category.name"
        :parent="withParentLabel"
        :cat-id="category.id"
      />
    </ul>
  </li>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import slugify from 'slugify';

export default {
  name: 'MobileTreeMenu',
  components: {
    SearchTonersInks: () => import('~/containers/Search/SearchTonersInks'),
  },
  props: {
    list: {
      type: Array,
      default: () => {},
    },
    icon: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    slug: {
      type: String,
      default: undefined,
    },
    count: {
      type: Number,
      default: undefined,
    },
    href: {
      type: String,
      default: undefined,
    },
    parent: {
      type: String,
      default: '',
    },
    catId: {
      type: Number,
      default: undefined,
    },
    menuName: {
      type: String,
      default: 'category',
    },
  },
  computed: {
    ...mapState('layout', ['activeMenuItem']),
    ...mapGetters('notifications', ['unreadNotifications']),
    withParentLabel() {
      return this.parent ? `${this.parent}-${this.label}` : this.label;
    },
  },
  methods: {
    slugify,
    ...mapActions({
      changeCategory: 'productsFilters/changeCategory',
    }),
    ...mapMutations({
      toggleMenu: 'layout/toggleMenuOpened',
      toggleActiveItem: 'layout/toggleActiveMenuItem',
    }),
    openNext() {
      this.toggleActiveItem({ type: this.menuName, item: slugify(this.withParentLabel) });
    },
    openPrev() {
      this.toggleActiveItem({ type: this.menuName, item: slugify(this.parent) });
    },
    resetMenuState() {
      this.toggleMenu({ type: this.menuName });
      this.toggleActiveItem({ type: this.menuName });
    },
  },
};
</script>
